export const CREATOR_OPTION_DISPLAY_LIMIT = 500;
export const CREATOR_SEARCH_RESULT_LIMIT = 500;
export const CREATOR_SEARCH_REQUEST_PAGE_SIZES = [200, 200, 100] as const;
export const CREATOR_SEARCH_DEBOUNCE_MS = 200;
